var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('checklist.sidebar.shortTitle'),"logo":_vm.$store.getters.systemLogoSidebar,"titleImg":_vm.$store.getters.systemTitleImage,"title":_vm.$store.getters.systemTile}},[_c('template',{slot:"links"},[_c('sidebar-item',{ref:"sidebarItemForms",attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          path: '/financial/dashboard',
          icon: 'tim-icons icon-chart-pie-36'
        }}}),_c('sidebar-item',{ref:"sidebarItemForms",attrs:{"link":{
          name: _vm.$t('financial.global.sales'),
          icon: 'tim-icons icon-coins'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('financial.global.sale'),
            path: '/financial/sales/list',
            icon: 'tim-icons icon-upload'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('financial.global.estimate'),
            path: '/financial/sales/estimate',
            icon: 'tim-icons icon-upload'
          }}})],1),_c('sidebar-item',{ref:"sidebarItemForms",attrs:{"link":{
          name: _vm.$t('financial.global.purchases'),
          path: '/financial/purchases/list',
          icon: 'tim-icons icon-basket-simple'
        }}}),_c('sidebar-item',{ref:"sidebarItemForms",attrs:{"link":{
          name: _vm.$t('sidebar.product'),
          path: '/financial/product/list',
          icon: 'tim-icons icon-app'
        }}}),_c('sidebar-item',{ref:"sidebarItemForms",attrs:{"link":{
          name: _vm.$t('sidebar.service'),
          path: '/financial/service/list',
          icon: 'tim-icons icon-laptop'
        }}}),_c('sidebar-item',{ref:"sidebarItemForms",attrs:{"link":{
          name: _vm.$t('financial.global.enterprise'),
          path: '/financial/enterprise/list',
          icon: 'tim-icons icon-badge'
        }}}),_c('sidebar-item',{ref:"sidebarItemForms",attrs:{"link":{
          name: _vm.$t('financial.global.financialAccounts'),
          icon: 'tim-icons icon-bank'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('financial.global.bankAccounts'),
            path: '/financial/bankaccount/list',
            icon: 'tim-icons icon-upload'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('financial.global.banks'),
            path: '/financial/bank/list',
            icon: 'tim-icons icon-upload'
          }}})],1),_c('sidebar-item',{ref:"sidebarItemForms",attrs:{"link":{
          name: 'Favoritos',
          icon: 'tim-icons icon-shape-star'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Vendas por vendedor',
            path: '/financial/report/sales',
            icon: 'tim-icons icon-upload'
          }}})],1)],1)],2),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar',{attrs:{"module":"trackingShippingCompany"}}),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }